import RoleFormPage from "./role-form-page.jsx";

export default RoleFormPage;
